import { render, staticRenderFns } from "./MenuNotifications.vue?vue&type=template&id=2ce0680b&scoped=true"
import script from "./MenuNotifications.vue?vue&type=script&lang=js"
export * from "./MenuNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuNotifications.vue?vue&type=style&index=0&id=2ce0680b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0680b",
  null
  
)

export default component.exports